import { Checkbox, Image, Space, Table, Tag, Tooltip, Typography } from "antd"
import React, { useEffect, useState } from "react"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../../../firebase/config"
import moment from "moment"
import { ASAPOrder, OrderAndPrefix } from "../../../components/Orders/Helpers/OrderAndPrefix"
import "../../../styles/OrderTable.css"
import { formatNumberWithSpaces } from "../../Orders/Helpers/FormatNumbersWithSpaces"
import { calculateProjectedMeters } from "../../Orders/Helpers/CalculateProjectedMeters"

const { Text } = Typography

export default function WaitingList({ forMachine }) {
  const [waitingData, setWaitingData] = useState([])
  //loading for while data is sorting
  const [isSorting, setIsSorting] = useState(true)
  const [hiddenTechnical, setHiddenTechnical] = useState(true)

  let clientFIlters =
    waitingData &&
    waitingData.reduce((accumulator, item) => {
      const clientName = item.client.client
      const existingItem = accumulator.find((filterItem) => filterItem.text === clientName)

      if (existingItem) {
        existingItem.value = clientName
      } else {
        accumulator.push({
          text: clientName,
          value: clientName,
        })
      }

      return accumulator
    }, [])

  let productFilters =
    waitingData &&
    waitingData.reduce((accumulator, item) => {
      const productName = item.selectedProduct.product.productName
      const existingItem = accumulator.find((filterItem) => filterItem.text === productName)

      if (existingItem) {
        existingItem.value = productName
      } else {
        accumulator.push({
          text: productName,
          value: productName,
        })
      }

      return accumulator
    }, [])

  let materialFilter =
    waitingData &&
    waitingData.reduce((accumulator, item) => {
      const materialName = item.selectedProduct.material
      const existingItem = accumulator.find((filterItem) => filterItem.text === materialName)

      if (existingItem) {
        existingItem.value = materialName
      } else {
        accumulator.push({
          text: materialName,
          value: materialName,
        })
      }

      return accumulator
    }, [])

  const waitingPrintCols = [
    {
      title: "Nr.",
      dataIndex: "orderNumber",
      align: "center",
      sorter: (a, b) => a.justOrderNumber - b.justOrderNumber,
      render: (value, record) => (
        <Space>
          {ASAPOrder(record)}
          {OrderAndPrefix(record)}
        </Space>
      ),
    },
    {
      title: "Created",
      dataIndex: "created",
      align: "center",
      hidden: forMachine === "Arsoma",
      sorter: (a, b) => a.created.seconds - b.created.seconds,
      render: (value) => (
        <>
          <Text>{moment.unix(value.seconds).format("DD.MM.YYYY")}</Text>
        </>
      ),
    },
    {
      title: "Due D.",
      dataIndex: "orderDueDate",
      align: "center",
      sorter: (a, b) => a.orderDueDate.seconds - b.orderDueDate.seconds,
      key: "created",
      render: (value, record) => {
        const dueDate = moment.unix(value.seconds)
        const isOverdue = dueDate.isBefore(moment(), "day")
        if (isOverdue) {
          return <Tag color="red"> {dueDate.format("DD.MM.YYYY")}</Tag>
        } else {
          return <Tag color="blue">{dueDate.format("DD.MM.YYYY")}</Tag>
        }
      },
    },
    {
      title: "Client",
      dataIndex: ["client", "client"],
      align: "center",
      ellipsis: {
        showTitle: false,
      },
      filters: clientFIlters,
      onFilter: (value, record) => record.client.client.startsWith(value),
      filterSearch: true,
      render: (item) => (
        <Tooltip placement="topLeft" title={item}>
          {item}
        </Tooltip>
      ),
    },
    {
      title: "Product",
      dataIndex: ["selectedProduct", "product", "productName"],
      align: "center",
      filters: productFilters,
      onFilter: (value, record) => record.selectedProduct.product.productName === value,
      filterSearch: true,
      ellipsis: {
        showTitle: false,
      },
      render: (item) => (
        <Tooltip placement="topLeft" title={item}>
          {item}
        </Tooltip>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "labelCount",
      align: "center",
      width: "7%",
      sorter: (a, b) => a.labelCount - b.labelCount,
      render: (value) => <Text>{formatNumberWithSpaces(value)}</Text>,
    },
    // {
    //   title: "Die-cut",
    //   dataIndex: ["selectedProduct", "knifeCode"],
    //   align: "center",
    // },

    {
      title: "Width",
      dataIndex: ["selectedProduct", "labelWidth"],
      align: "center",
      width: "5%",
    },
    {
      title: "Height",
      dataIndex: ["selectedProduct", "labelHeight"],
      align: "center",
      width: "5%",
    },
    {
      title: "M.Width",
      dataIndex: ["selectedProduct", "formatWidth"],
      align: "center",
      sorter: (a, b) => a.selectedProduct.formatWidth - b.selectedProduct.formatWidth,
      render: (value, record) => {
        if (record.readRollWidth) {
          return <Text>{record.rollWidth}</Text>
        } else {
          return <Text>{value}</Text>
        }
      },
    },
    {
      title: "Proj. M.",
      dataIndex: ["projectedMeters"],
      align: "center",
      width: "7%",
      render: (value) => <Text>{formatNumberWithSpaces(value)}m</Text>,
    },
    {
      title: "Material",
      dataIndex: ["selectedProduct", "material"],
      align: "center",
      filters: materialFilter,
      onFilter: (value, record) => record.selectedProduct.material.startsWith(value),
      filterSearch: true,
      ellipsis: {
        showTitle: false,
      },
      render: (item) => (
        <Tooltip placement="topLeft" title={item}>
          {item}
        </Tooltip>
      ),
    },
    // {
    //   title: "Plate",
    //   dataIndex: ["selectedPlate", "code"],
    //   align: "center",
    //   ellipsis: {
    //     showTitle: false,
    //   },
    //   render: (item) => {
    //     if (item) {
    //       return (
    //         <Tooltip placement="topLeft" title={item}>
    //           {item}
    //         </Tooltip>
    //       )
    //     } else {
    //       return <ScissorOutlined style={{ color: "#f5222d" }} />
    //     }
    //   },
    // },
    {
      title: "Technical",
      dataIndex: "technicalPage",
      align: "center",
      render: (value) => (
        <>
          <Image src={value} />
        </>
      ),
    },
  ]

  // //fetches the documents, then uses the sequence array to sort in correct order
  useEffect(() => {
    const ref = collection(db, "orders")
    let q = query(
      ref,
      where("orderStatus", "==", 2),
      where("selectedProduct.machine", "==", forMachine)
    )

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      let orders = snapshot.docs.map((doc) => ({
        ...doc.data(),
        key: doc.id,
        id: doc.id,
      }))

      // Fetch knife data and calculate projected meters in batch
      const ordersWithKnifeData = await Promise.all(
        orders.map((order) => calculateProjectedMeters(order))
      )

      setWaitingData(ordersWithKnifeData)
      setIsSorting(false)
    })

    return () => unsubscribe()
  }, [forMachine]) // Dependency on vivaSequence ensures re-sort if sequence changes

  // Filter for hiding technical page
  const changeFilter = () => {
    setHiddenTechnical(!hiddenTechnical)
  }

  const columnsToShow = hiddenTechnical
    ? waitingPrintCols.filter((col) => col.dataIndex !== "technicalPage")
    : waitingPrintCols

  return (
    <>
      <Checkbox style={{ marginBottom: 15 }} defaultChecked onChange={changeFilter}>
        Hide/Show Technical
      </Checkbox>
      <Table
        bordered
        size="small"
        className="custom-table"
        rowKey={(record) => record.id}
        dataSource={waitingData}
        loading={isSorting}
        columns={columnsToShow} // Use the filtered columns
        rowClassName={(record) => (record.priorityOrder ? "red-background" : "")}
        pagination={{ pageSize: 40, showSizeChanger: true }}
      />
    </>
  )
}
